import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background-color: #f2f2f2;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: 5rem 0;

  @media (min-width: 62rem) {
    height: 45rem;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;

  @media (min-width: 62rem) {
    width: 62rem;
    flex-flow: column wrap;
  }
`;
